import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = loading, false = unauthenticated, object = user
  const [user, setUser] = useState(null);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem("telemed_token");
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (_e) {
      localStorage.removeItem("telemed_token");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const setSession = (token, userObj) => {
    localStorage.setItem("telemed_token", token);
    setUser(userObj);
  };

  const logout = () => {
    localStorage.removeItem("telemed_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setSession, logout, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
